import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';

import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { fetchPredefinedRulesList } from "../../../api's/DataProcessorApi";
import InputField from '../../../reusable-component/InputField';

const AddPredefinedRuleModal = ({
  columnName,
  metricList,
  disableForm,
  open,
  handleClose,
  handleGenerateRulesForEdit,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [predefinedRuleList, setPredefinedRuleList] = useState([]);

  const getPredefinedRuleList = async () => {
    try {
      const response = await fetchPredefinedRulesList();
      if (response.status === 200) {
        setPredefinedRuleList(response.data);
      }
    } catch (error) {
      enqueueSnackbar('Error while fetching Predefined Rule List!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  useEffect(() => {
    getPredefinedRuleList();
  }, []);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3.5,
  };

  const handleCancel = () => {
    handleClose();
  };

  const INITIALSTATE = {
    metric: '',
    fieldName: '',
    firstSampleValue: '',
    secondSampleValue: '',
    statement: '',
    category: '',
    ruleName: '',
  };

  const [formField, setFormField] = useState(INITIALSTATE);

  const handleChange = (event, source, statementValue) => {
    switch (source) {
      case 'metric': {
        setFormField({
          ...formField,
          metric: event.target.value,
        });
        break;
      }
      case 'fieldName': {
        setFormField({
          ...formField,
          fieldName: event.target.value,
        });
        break;
      }
      case 'firstSampleValue': {
        setFormField({
          ...formField,
          firstSampleValue: event.target.value,
        });
        break;
      }
      case 'secondSampleValue': {
        setFormField({
          ...formField,
          secondSampleValue: event.target.value,
        });
        break;
      }
      case 'ruleName': {
        console.log(event.target.value);
        setFormField({
          ...formField,
          ruleName: event.target.value,
          statement: statementValue,
        });
        break;
      }
      case 'category': {
        setFormField({
          ...formField,
          category: event.target.value,
        });
        break;
      }

      default:
        break;
    }
  };
  const handleAddCustomRule = async () => {
    const data = {
      metric: formField.metric,
      fieldName: formField.fieldName,
      statement: formField.statement,
      fieldValues: [formField.firstSampleValue, formField.secondSampleValue],
    };

    handleClose();

    await handleGenerateRulesForEdit(data, true, false);
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box>
            <Typography variant="p" component="p" sx={{ fontWeight: '550', textTransform: 'uppercase' }}>
              PREDEFINED RULE MODAL
            </Typography>
          </Box>
          <>
            <Grid container spacing={2} mt={0}>
              <Grid item xs={6}>
                <FormControl size="small" sx={{ width: '100%' }}>
                  <InputLabel>Column Name</InputLabel>
                  <Select
                    id="demo-simple-select-helper"
                    name="columnName"
                    size="small"
                    label="Column Name"
                    value={formField?.fieldName}
                    onChange={(e) => handleChange(e, 'fieldName')}
                    sx={{ background: '#ffffff' }}
                  >
                    {columnName
                      ?.sort((a, b) => a.label?.localeCompare(b.label))
                      ?.map((item) => (
                        <MenuItem key={item.id} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl size="small" sx={{ width: '100%' }}>
                  <InputLabel>Category</InputLabel>
                  <Select
                    id="demo-simple-select-helper"
                    value={formField.category}
                    onChange={(e) => handleChange(e, 'category')}
                    size="small"
                    label="Category"
                    name="category"
                    sx={{ background: '#ffffff' }}
                  >
                    {predefinedRuleList
                      ?.sort((a, b) => a.category?.localeCompare(b.category))
                      ?.map((item) => (
                        <MenuItem key={item.rm_id} value={item.category}>
                          {item.category}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {formField?.category && (
              <>
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={6}>
                    <FormControl size="small" sx={{ width: '100%' }}>
                      <InputLabel>Rule Name</InputLabel>
                      <Select
                        id="demo-simple-select-helper"
                        name="ruleName"
                        size="small"
                        label="Rule Name"
                        value={formField.ruleName}
                        onChange={(e) => {
                          const statementValue =
                            predefinedRuleList
                              ?.filter((item) => formField?.category === item.category)
                              ?.flatMap((item) => item.rules_list)
                              ?.find((item) => e.target.value === item.rule_name)?.format || '';
                          handleChange(e, 'ruleName', statementValue);
                        }}
                        key={formField.ruleName}
                        disabled={disableForm}
                        sx={{ background: '#ffffff' }}
                      >
                        {predefinedRuleList
                          ?.filter((item) => formField.category === item.category)
                          ?.flatMap((item) => item.rules_list)
                          ?.map((item) => (
                            <MenuItem key={item.ru_id} value={item.rule_name}>
                              {item.rule_name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl size="small" sx={{ width: '100%' }}>
                      <InputLabel>Metric</InputLabel>
                      <Select
                        id="demo-simple-select-helper"
                        name="metric"
                        size="small"
                        label="Metric"
                        value={formField.metric}
                        onChange={(e) => handleChange(e, 'metric')}
                        key={formField.id}
                        disabled={disableForm}
                        sx={{ background: '#ffffff' }}
                      >
                        {metricList
                          ?.sort((a, b) => a.metric_type?.localeCompare(b.metric_type))
                          ?.map((item) => (
                            <MenuItem key={item.rm_id} value={item.metric_type}>
                              {item.metric_type}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputField
                      name="sampleValue1"
                      label="Sample Value 1"
                      value={formField.firstSampleValue}
                      onChange={(e) => handleChange(e, 'firstSampleValue')}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputField
                      name="sampleValue2"
                      label="Sample Value 2"
                      value={formField.secondSampleValue}
                      onChange={(e) => handleChange(e, 'secondSampleValue')}
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={12}>
                    <Tooltip title={formField.statement || ''} arrow>
                      <TextField
                        style={{ width: '100%', margin: '0px 2% 8px 0' }}
                        label="Statement"
                        id="outlined-size-small"
                        margin="none"
                        name="statement"
                        size="small"
                        disabled
                        value={formField.statement}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              </>
            )}
            <Grid container justifyContent="center" mt={2} mb={-1}>
              <Grid item>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid item>
                    <Button
                      size="small"
                      type="cancel"
                      variant="contained"
                      sx={{
                        backgroundColor: '#ffffff',
                        '&:hover': { backgroundColor: '#ffffff' },
                        color: '#00043C',
                        border: '1px solid black',
                      }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="small"
                      type="submit"
                      variant="contained"
                      sx={{
                        backgroundColor: '#00043C',
                        '&:hover': { backgroundColor: '#00043C' },
                        color: '#ffffff',
                      }}
                      onClick={handleAddCustomRule}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        </Box>
      </Modal>
    </>
  );
};

export default AddPredefinedRuleModal;
